import { back, hamburger } from "@/assets/images/index";
import { useDesignMaxTheme } from "@/packages";
import { useToggleState } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, IconButton, Menu } from "@chakra-ui/react";
import { type PropsWithChildren } from "react";

export const ToggleMenu = ({ children }: PropsWithChildren) => {
    const [isMenu, setIsMenu] = useToggleState();
    const { COLORS } = useDesignMaxTheme();

    return (
        <Center
            sx={{
                "& > button": {
                    position: "relative",
                    zIndex: 3,
                    ...FONT("cormorant", 16, 700),
                    transition: "1s cubic-bezier(0.215, 0.61, 0.355, 1)",
                    color: COLORS.black,
                },
            }}
        >
            <Menu>
                <Box
                    className="hamburger_menu"
                    as={IconButton}
                    borderRadius="none"
                    w="40px"
                    h="24px"
                    color={!isMenu ? `black !important` : "white"}
                    onClick={() => setIsMenu((prev) => !prev)}
                    background={
                        !isMenu ? `url(${hamburger})no-repeat center/cover` : `url(${back})no-repeat center/cover`
                    }
                    sx={{
                        _hover: {
                            background: !isMenu
                                ? `url(${hamburger})no-repeat center/cover`
                                : `url(${back})no-repeat center/cover`,
                        },
                    }}
                />
            </Menu>
            <Box
                position="absolute"
                w="100%"
                h="100vh"
                top="-100vh"
                left="0"
                boxSizing="border-box"
                transition="1s cubic-bezier(0.215, 0.61, 0.355, 1)"
                bgColor="#fbf6f2"
                zIndex="2"
                className={isMenu ? "on" : "off"}
                sx={{
                    "&.on": {
                        top: 0,
                    },
                }}
            >
                {children}
            </Box>
        </Center>
    );
};
